import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import { postUnsubscribeFailure, postUnsubscribeSuccess } from 'modules/customers/actions';

/** @typedef {boolean} IsReadyState */
const initialState = false;

const set = () => true;

export default createReducer(initialState, (builder) => {
  builder.addMatcher(isAnyOf(postUnsubscribeSuccess.match, postUnsubscribeFailure.match), set);
});
